export default {
  auth: {
    login: 'Anmelden',
    logout: 'Ausloggen',
    no_match: 'Ihre Passwörter stimmen nicht überein',
    forgot: {
      title: 'Passwort vergessen',
      instruction: 'Geben Sie Ihre E-Mail-Adresse ein, um eine Anleitung zur Erstellung eines neuen Passworts zu erhalten.',
      confirmation: 'Ein neues Passwort wurde an Ihre E-Mail gesendet.',
      submit: 'Wiederherstellen',
    },
    reset: {
      title: 'Passwort zurücksetzen',
      description: 'Erstellen Sie ein neues Passwort.',
      submit: 'Zurücksetzen',
      submitted: 'Ihr Passwort wurde aktualisiert.'
    },
    submitted: {
      success: 'Erledigt!',
      sent: 'Wir haben Ihnen eine E-Mail an {email} gesendet.',
      again: 'Erneut anmelden',
    },
    required: {
      email: 'Ungültige E-Mail',
      password: 'Passwort ist erforderlich',
      default: 'Erforderlich',
      name: 'Ungültiger Name',
      url: 'Ungültige URL',
      number: 'Nur Zahlen erlaubt',
      passwordRules: {
        lowercase: 'Mindestens ein Kleinbuchstabe erforderlich',
        uppercase: 'Mindestens ein Großbuchstabe erforderlich',
        length: 'Mindestens 8 Zeichen',
        number: 'Mindestens eine Zahl erforderlich',
        special: 'Mindestens ein Sonderzeichen erforderlich',
        match: 'Die Passwörter müssen übereinstimmen',
      },
    },
  },
  actions: {
    back: 'Zurück',
    next: 'Weiter',
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    save: 'Speichern',
    create: 'Erstellen',
    close: 'Schließen',
    esc: 'Esc',
  },
  labels: {
    description: 'Beschreibung',
  },
  event: {
    title: 'Stundenerfassung',
    dialog: {
      create: 'Erstellen',
      edit: 'Bearbeiten',
      remove: 'Löschen',
    },
  },
  user: {
    add: '{item} hinzufügen',
    title: 'Benutzer',
    statuses: {
      active: 'Aktiv',
      blacklist: 'Blacklist',
      discontinued: 'Eingestellt',
      openInvoice: 'Offene Rechnung',
    },
  },
  mfa: {
    title: 'MFA-Token',
  },
  roles: {
    user: 'Benutzer | Benutzer',
    title: 'Benutzer'
  },
  request:
  {
    request: 'Anfrage',
    boxRequestNotFound: 'Box-Anfrage nicht gefunden oder kann nicht geladen werden.',
    assignedAt: 'Zugewiesen am',
    noLogsAvailable: 'Keine Protokolle verfügbar',
    statusChangedTo: 'status geändert zu',
    by: 'von',
  },
  table: {
    found: '{total} {name} gefunden',
    perPage: '{name} pro Seite:',
    noData: 'Keine Daten verfügbar',
    filter: 'Nach {name} filtern:',
    listView: 'Listenansicht',
    kanBanView: 'Kanban-Ansicht',
    toggleFilters: 'Filter umschalten',
  },
  tableHeaders: {
    name: {
      title: 'Name',
      first: 'Vorname',
      middle: 'Zweiter Vorname',
      last: 'Nachname',
    },
    age: {
      title: 'Alter',
    },
    email: {
      title: 'E-Mail'
    },
    phone: {
      title: 'Telefon'
    },
    created_at: {
      title: 'Erstellt am',
    },
    price: {
      title: 'Preis',
    },
    code: {
      title: 'Code',
    },
    percentage: {
      title: 'Prozentsatz',
    },
    status: {
      title: 'Status',
    },
    adressChecked: {
      title: 'Adresse Geprüft',
    },
    city: {
      title: 'Stadt',
    },
    number: {
      title: 'Zahl',
    },
    userID: {
      title: 'User ID',
    },
    createdAt: {
      title: 'Erstellt Am',
    },
    client: {
      title: 'Kunde',
    },
    type: {
      title: 'Typ',
    },
    stylist: {
      title: 'Stylist',
    },
    note: {
      title: 'Notiz',
    },
    boxNumber: {
      title: 'Box #',
    },
    channel: {
      title: 'Kanal',
    },
    assignedAt: {
      title: 'Zugewiesen am',
    },
    lastStatusUpdate: {
      title: 'Letztes Statusupdate',
    },
    lastUpdate: {
      title: 'Letzte Aktualisierung',
    },
    orderNumber: {
      title: 'Auftrag #',
    },
    quantity: {
      title: 'Menge',
    },
    quantitySold: {
      title: 'Verkaufte Menge',
    },
    netSales: {
      title: 'Nettoumsatz',
    },
    finalized: {
      title: 'Abgeschlossen',
    },
    dispatched: {
      title: 'Versandt',
    },
    finalReturn: {
      title: 'Endgültige Rücksendung',
    },
    returned: {
      title: 'Zurückgegeben',
    },
    picked: {
      title: 'Kommissioniert'
    },
    barcode: { title: 'Barcode' },
    offeredOn: { title: 'Angeboten am' },
    deliveryDate: { title: 'Lieferdatum' },
    labels: { title: 'Etiketten' },
    understanding: { title: 'Verständnis' },
  },
  navigation: {
    users: 'Benutzer',
  },
  profile: {
    referral_code: 'Empfehlungscode',
    title: 'Profil | Profile',
    setting: 'Einstellungen | Einstellungen ',
    mine: 'Mein Profil',
    standard: 'Standardinformationen',
    contact: {
      information: 'Kontaktinformation',
      person: 'Ansprechpartner',
      number: 'Kontaktnummer',
    },
    dob: 'Geburtsdatum',
    name: 'Name',
    firstName: 'Vorname',
    middleName: 'Zweiter Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefonnummer',
    website: 'Webseite',
    country: 'Land',
    password: {
      title: 'Neues Passwort',
      forgot: 'Passwort vergessen?',
      current: 'Aktuelles Passwort',
      confirm: 'Passwort bestätigen',
      change: 'Passwort ändern',
      save: 'Passwort speichern',
      saved: 'Passwort gespeichert',
    },
    group: 'Gruppe',
    login: 'Anmelden als',
    address: 'Adresse',
    street: 'Straße',
    housenumber: 'Hausnummer',
    addition: 'Zusatz',
    postcode: 'PLZ',
    city: 'Stadt',
    budgetHours: 'Budgetstunden',
    budgetMoney: 'Budget Geld',
    code: 'Code',
    color: 'Farbe',
    invoiceName: 'Rechnungsname',
    calculationModel: 'Berechnungsmodell',
    responsibleEmployee: 'Mitarbeiter',
  },
  avatar: {
    title: 'Profilbild',
    change: 'Bild ändern',
  },
  general: {
    back: 'Zurück',
    search: 'Suchen | Suchen',
    cancel: 'Abbrechen',
    yes: 'Ja',
    no: 'Nein',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    startsAt: 'Beginnt am',
    endsAt: 'Endet am',
  },
  time: {
    year: 'Jahr | Jahre',
    month: 'Monat | Monate',
    week: 'Woche | Wochen',
    day: 'Tag | Tage',
    hour: 'Stunde | Stunden',
    minute: 'Minute | Minuten',
  },
  inbox: {
    title: '',
    menu: {
      inbox: 'Posteingang',
      starred: 'Markiert',
      sent: 'Gesendet',
      draft: 'Entwurf',
      create: 'Neue E-Mail',
      folders: 'Ordner',
    },
    actions: {
      delete: 'Löschen',
      reply: 'Antworten',
      archive: 'Archivieren',
      sent: 'Gesendet'
    },
    contact: 'Contakt | Contakte'
  },
  form: {
    formFields: {
      avatar: 'Avatar',
      supplierName: 'Name des Lieferanten',
      firstName: 'Vorname',
      lastName: 'Nachname',
      middleName: 'Zweiter Vorname',
      name: 'Name',
      invoiceName: 'Rechnungsname',
      website: 'Webseite',
      phone: 'Telefon',
      username: 'Benutzername',
      email: 'E-Mail',
      password: 'Passwort',
      category: 'Kategorie',
      confirmPassword: 'Passwort bestätigen',
      code: 'Code',
      percentage: 'Prozentsatz',
      color: 'Projektfarbe',
      token: 'MFA-Token',
      value: 'Wert',
      country: {
        title: 'Land',
        nl: 'Niederländisch',
        en: 'Englisch',
        de: 'Deutsch',
      },
    },
    optional: 'Optional',
    fieldsRequiredText: 'Alle Felder sind erforderlich',
  },
  languages: {
    title: 'Sprache',
    nl: 'Niederländisch',
    en: 'Englisch',
    de: 'Deutsch'
  },
  createDialog: {
    header: {
      create: 'Erstellen',
      overview: 'Übersicht',
      finished: 'Fertiggestellt',
    },
    body: {
      title: {
        activate: 'Aktiviere den/die {role}',
        create: 'Erstelle einen neuen {role}',
        finished: '{role} wurde erstellt',
        information: '{role}-Informationen',
        address: 'Adresse des Schuldners',
        postAddress: 'Postanschrift',
        officeAddress: 'Geschäftsanschrift',
      },
      description: {
        confirm: 'Bestätige, dass alle Informationen für den neuen {role} korrekt sind',
        finished: 'Siehe unten das erstellte {role}',
      },
      upload: 'Hochladen',
    },
    actions: {
      reset: 'Weiteren {role} erstellen',
    },
  },
  dialogOptions: {
    item: {
      client: 'Kunde',
      subscriptionType: 'Abonnementtyp',
    },
    confirmation: 'Bestätigung',
    delete: 'Möchten Sie dieses {item} wirklich löschen? | Möchten Sie diese {item} wirklich löschen?',
    deleteMany: 'Möchten Sie {item} wirklich löschen?',
    lessonT: 'Möchten Sie zu diesem {item} gehen?',
    save: '{item} wurde gespeichert',
    update: 'Möchten Sie dieses {item} wirklich aktualisieren? | Möchten Sie diese {item} wirklich aktualisieren?',
    existingOrderFound: 'Bestehende Bestellung gefunden',
    existingOrderFoundForClient: 'Es wurde bereits eine Bestellung für diesen Kunden gefunden',
    showOrder: 'Bestellung anzeigen',
    button: {
      delete: 'Löschen',
      cancel: 'Abbrechen',
      ok: 'Ok',
    },
  },
  bugReport: {
    title: 'Fehler',
    header: 'Einen Fehler melden',
    field: {
      title: 'Titel',
      description: 'Beschreibung',
      screenshot: 'Screenshot',
    },
    create: {
      title: 'Fügen Sie einen Titel hinzu',
      description: 'Fügen Sie eine Beschreibung hinzu.',
      descriptionExplanation: 'Wann ist dieser Fehler aufgetreten? Welche Schritte und/oder Aktionen haben Sie durchgeführt? Auf welche Schaltflächen haben Sie geklickt?',
      screenshot: 'Screenshot',
      submitBug: 'Fehler melden',
      created: 'Ihr Fehlerbericht wurde erstellt.',
      downloadScreenshot: 'Bild herunterladen',
      uploadScreenshot: 'Laden Sie das heruntergeladene Bild im Link hoch',
    },
    alert: {
      noIdSet: 'Montag Board ID oder Gruppen-ID ist nicht gesetzt, kann keinen Pulse erstellen',
      warning: 'Warnung',
    },
    reportContent: {
      description: 'Beschreibung',
      localStorage: 'Lokaler Speicher',
      stacktrace: 'Stacktrace',
      message: 'Nachricht',
      file: 'Datei',
      line: 'Zeile',
      column: 'Spalte',
      error: 'Fehler',
    },
  },
  errors: {
    loading: {
      description: 'Es gab ein Problem beim Laden der erforderlichen Informationen.',
      suggestion: 'Bitte versuchen Sie es später noch einmal.',
    },
    notFound: {
      description: 'Die gesuchte Seite konnte nicht gefunden werden.',
      suggestion: '404',
      url: 'Bitte überprüfen Sie die URL auf Tippfehler',
      error: '404 FEHLER.',
      back: 'Zur Startseite',
      oops: 'Hoppla :(',
      or: 'oder',
      contact: 'kontaktieren Sie uns unter',
    },
  },
  hours: {
    hour: 'Stunde | Stunden',
  },
  contact: 'Kontakt',
  contacts: 'Kontakte',
  menu: {
    contacts: 'Kontakte',
    requests: 'Aufforderungen',
    orders: 'Aufträge',
  },
  hamburgerMenu: {
    account: 'Mein Konto',
    settings: 'Einstellungen',
  },
  filters: {
    filters: 'Filter',
    statusFilter: {
      toBeContacted: 'Zu kontaktieren',
      waitingForReply: 'Warten auf Antwort',
      noReply: 'Keine Antwort',
      orderInProgress: 'Zu stylen',
      completed: 'Abgeschlossen',
    },
    typeFilter: {
      swapBox: 'Tauschbox',
      styledBox: 'Gestylte Box',
      studio: 'Studio',
      afterSales: 'Kundendienst',
      promotion: 'Promotion',
      supplierReturn: 'Lieferantenrückgabe',
      swipeToShop: 'Swipe-zum-Kauf',
      shopify: 'Shopify',
      stylingFee: 'Stylinggebühr',
      other: 'Andere',
    },
    orderStatusFilter: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
      preview: 'Vorschau',
      finalized: 'Abgeschlossen',
      checkout: 'Kasse',
      invoiced: 'In Rechnung gestellt',
      completed: 'Abgeschlossen',
      lost: 'Verloren',
      cancelled: 'Storniert',
      allocated: 'Zugewiesen',
      partiallyAllocated: 'Teilweise zugewiesen',
      picked: 'Kommissioniert',
      partiallyPicked: 'Teilweise kommissioniert',
      shipped: 'Versandt',
      partiallyShipped: 'Teilweise versandt',
      dispatched: 'Verschickt',
      partiallyDispatched: 'Teilweise verschickt',
    },
    finalReturnDate: 'Letztes Rückgabedatum',
  },
  contactsPage: {
    cardview: {
      newOrder: 'Neue Bestellung erstellen',
      editStatus: 'Status bearbeiten',
      createNewOrder: 'Neue Bestellung erstellen',
      finishOrder: 'Bestellung abschließen',
      fillAdress: 'Geben Sie die Adressdaten ein und fahren Sie mit der Bestellung fort',
    },
    quizView: {
      styleQuiz: 'Stilquiz',
      quizCreatedAt: 'Quiz erstellt am:',
      style: 'Stil',
      bodyType: 'Körpertyp',
      preferences: 'Einstellungen',
      myFotos: 'Meine Fotos',
      box: 'Box',
      notes: 'Stylisten-Notizen',
    },
    attachments: 'Anhänge',
    listView: {
      search: 'Suchen',
      signUpDate: 'Datum der Anmeldung',
    },
  },
  orders: {
    checkOrder: 'Bestellung ansehen',
    orderDetail: {
      orderItems: 'Bestellte Artikel',
      relatedSets: 'Verwandte Sets',
      evaluation: 'Bewertung',
      attachments: 'Anhänge',
      labels: 'Etiketten',
      updateOrder: 'Bestellung aktualisieren',
      orderItemsBlock: {
        notAllocatedItems: 'Nicht zugewiesene Artikel',
        itemName: 'Artikelname',
        quantity: 'Menge',
        price: 'Preis',
        tax: 'Steuer',
        total: 'Gesamt',
        allocatedItems: 'Zugewiesene Artikel',
        noItemsAreAllocated: 'Keine Artikel zugewiesen',
        pickedItems: 'Ausgewählte Artikel',
        noItemsArePicked: 'Keine Artikel ausgewählt',
        dispatchedItems: 'Versandte Artikel',
        noItemsAreDispatched: 'Keine Artikel versandt',
        returnedItems: 'Zurückgesandte Artikel',
        noItemsAreReturned: 'Keine Artikel zurückgesandt',
        returnBatch: 'Rücksendung',
        keptItems: 'Behaltene Artikel',
        discount: 'Rabatt',
        noItemsAreKept: 'Keine Artikel behalten',
        totalUnits: 'Gesamteinheiten',
        subTotal: 'Zwischensumme',
        referralDiscount: 'Empfehlungsrabatt',
        includingVat: 'Inklusive MwSt. (21%)',
        returnDate: 'Rückgabedatum',
        orderDiscount: 'Bestellrabatt',
      },
      relatedSetsBlock: {
        newSet: 'Neues Set',
        size: 'Größe:',
        brand: 'Marke:',
        editPersonalNote: 'Persönliche Notiz bearbeiten',
        createdAt: 'Erstellt am',
        cancel: 'Abbrechen',
      },
      evaluationBlock: {
        orderEvaluation: 'Auswertung von Aufträgen',
        stylistUnderstanding: 'Inwiefern haben Sie das Gefühl, dass Ihr Stylist Ihren Stil gut verstanden hat?',
        anotherBox: 'Glaubst du, du möchtest noch eine Box erhalten?',
        satisfiedWithBox: 'Wie zufrieden sind Sie mit der Box?',
        willYouAdvise: 'Wie wahrscheinlich ist es, dass Sie Maison365 anderen empfehlen?',
        isTheChoiceGood: 'Inwieweit stimmen Sie der Aussage zu, dass Maison365 es einfach macht, schöne Kleidung zu bekommen?',
      },
      orderedItemsEvaluation: {
        orderItemsEvaluation: 'Auswertung von Auftragspositionen',
        product: 'Produkt',
        overall: 'Insgesamt',
        fit: 'Passform',
        style: 'Stil',
        other: 'Sonstiges',
        good: 'Gut',
        size: 'Größe',
        tooLarge: 'Zu groß',
        tooSmall: 'Zu klein',
        keep: 'Behalten',
        return: 'Zurückgeben',
        exchange: 'Umtauschen',
        tooWide: 'Zu weit',
        tooTight: 'Zu eng',
        tooLong: 'Zu lang',
        tooShort: 'Zu kurz',
        tooSimple: 'Zu einfach',
        tooBusy: 'Zu auffällig',
        tooSolid: 'Zu solide',
        tooYoung: 'Zu jung',
        colorNotNice: 'Farbe nicht schön',
        printNotNice: 'Druck nicht schön',
        materialFinishingNotNice: 'Material/Verarbeitung nicht schön',
        tooExpensive: 'Zu teuer',
        alreadyHaveSomethingSimilar: 'Ich habe schon so etwas',
        generalEvaluation: "Gesamtbewertung",
        sizeEvaluation: "Größenbewertung",
        fitEvaluation: "Passformbewertung",
        styleEvaluation: "Stilbewertung",
        otherEvaluation: "Weitere Bewertung",
      },
      attachmentsBlock: {
        orderAttachments: 'Auftragsanhänge',
        noOrderAttachments: 'Es gibt keine Auftragsanhänge',
        seeOrderAttachments: 'Siehe Auftragsanhänge',
      },
      listView: {
        nanOrdersFound: 'NaN Orders gefunden',
        search: 'Suchen',
        ordersPerPage: 'Bestellungen pro Seite',
      },
      webshop: {
        filters: {
          search: 'Suchen',
          colors: 'Farben',
          brands: 'Schutzmarken',
          suppliers: 'Lieferanten',
          categories: 'Kategorien',
          tags: 'Schilder',
          materials: 'Materialien',
          price: 'Preis',
          sizes: 'Größen',
          season: 'Jahreszeit',
          pantsLength: 'Hose: Länge',
          details: 'Details',
          sustainable: 'Nachhaltig',
          pantsFit: 'Hose: Passform',
          jacketsFit: 'Jacken: Passform',
          dressesFit: 'Kleider: Passform',
          topsFit: 'Oberteile: Passform',
          collar: 'Kragen',
          jacketsLength: 'Jacken: Länge',
          dressesLength: 'Kleider: Länge',
          topsLength: 'Oberteile: Länge',
          sizeGuide: 'Größentabelle',
          material: 'Material',
          sleeveSize: 'Ärmelgröße',
          pattern: 'Muster',
          closure: 'Schließung',
          style: 'Stil',
          pantsType: 'Hose: Typ',
          jacketsType: 'Jacken: Typ',
          skirtType: 'Rock: Typ',
          rerun: 'Wiederaufführung',
          dummyUPC: 'Dummy UPC',
          removeAllFilters: 'Alle Filter entfernen',
        },
        styleView: {
          availableSizes: 'Verfügbare Größen',
        },
        sideBar: {
          height: 'Höhe',
          cup: 'Tasse',
          jeans: 'Jeans',
          tops: 'Oberteile',
          topSize: 'Top Größe',
          bottomSize: 'Untere Größe',
          customer: 'Kunde',
          style: 'Stil',
          brands: 'Schutzmarken',
          keywords: 'Schlüsselwörter',
          dresscodeAtWork: 'Dresscode am Arbeitsplatz',
          monthlyBudget: 'Monatliches Budget',
          colors: 'Farben',
          shoppingCart: 'Einkaufswagen',
          size: 'Größe',
          total: 'Gesamt:',
          createSets: 'Sets erstellen',
          client: 'Kunde',
          items: 'Artikel',
          colorDontUse: 'Welche Farben tragen Sie nicht',
          fabricDontUse: 'Welche Stoffe tragen Sie nicht',
          patternDontUse: 'Welche Muster tragen Sie nicht',
          camouflage: 'Camouflage',
          motivation: 'Motivation',
          thisBox: 'Diese Box',
          lookingFor: 'Hauptsächlich auf der Suche nach',
          specificItems: 'Spezifische Artikel, die der Kunde erhalten möchte',
          other: 'Andere',
          shapePreferenceTops: 'Passformpräferenz für Oberteile',
          budget: 'Budget',
          trousers: 'Hosen',
          fittingTrousers: 'Wie passen Hosen normalerweise an Ihrer Taille?',
          skirts: 'Röcke',
          dresses: 'Kleider',
          lengthSkirt: 'Welche Rocklänge passt Ihnen?',
          accessories: 'Accessoires',
          describeAccessories: 'Wie würden Sie Ihren Stil für Accessoires und Schmuck beschreiben?',
          preferenceColor: 'Bevorzugte Schmuckfarbe',
          earsPierced: 'Haben Sie Ohrenpiercings?',
          noProductsCart: 'Es sind keine Produkte im Warenkorb',
        },
        productView: {
          backToTheShop: 'Zurück zum Shop',
          inStock: 'Auf Lager',
          productDetailsPhotosOkNotOk: 'Produktdetails & Fotos OK/PAS OK für Farbe Dunkelblau, Größe 36?',
          addToCart: 'In den Warenkorb',
          color: 'Farbe',
          productAttributes: 'Produkteigenschaften',
          supplierCode: 'Lieferantencode',
          location: 'Standort',
          selectOtherSize: 'Andere Größe auswählen',
          outOfStock: 'Nicht vorrätig',
          productAlreadyInCart: 'Dieses Produkt ist bereits in Ihrem Warenkorb',
          availableInShopify: 'Auf Shopify verfügbar',
          reserved: 'Reserviert',
          noMaterials: 'Keine Materialien für dieses Produkt',
          noTags: 'Keine Tags für dieses Produkt',
        },
        sets: {
          addAllToOtherItems: "Alles zu 'Andere Artikel' hinzufügen",
          otherItems: 'Andere Artikel',
          totalPrice: 'Gesamtpreis:',
          totalProducts: 'Gesamtprodukte:',
          createPersonalNote: 'Persönliche Notiz erstellen',
          newSet: 'Neues Set',
          back: 'Zurück',
          tip: 'TIPP:',
          packInThisSet: 'In dieses Set verpacken',
          setExplanation: 'Set-Erklärung',
        },
        personalNote: {
          personalNote: 'Persönliche Notiz',
          updatePersonalNote: 'Persönliche Notiz aktualisieren',
          totalPrice: 'Gesamtpreis:',
          totalProducts: 'Gesamtprodukte:',
          finalizeThisOrder: 'Diese Bestellung abschließen',
          introText: 'Einleitungstext',
          noExplanationForSet: 'Es wurde keine Erklärung für dieses Set gegeben',
          outroText: 'Abschlusstext',
          back: 'Zurück',
          originalText: 'Originaltext',
          selectLanguageNote: 'Wählen Sie die Sprache der persönlichen Notiz für Ihren Kunden',
          inOriginalLanguage: 'In der Originalsprache anzeigen',
          translateToOtherLanguage: 'In eine andere Sprache übersetzen',
          selectLanguage: 'Sprache auswählen',
          translatedText: 'Übersetzter Text',
          translate: 'Übersetzen',
          orderSucceded: 'Bestellung erfolgreich',
          orderDefinitive: 'Die Bestellung wurde endgültig abgeschlossen.',
          orderOverview: 'Zur Bestellübersicht gehen',
          editPersonalNotes: 'Persönliche Notizen bearbeiten',
          update: 'Aktualisieren',
          cancel: 'Abbrechen',
          sureYouWantToUpdate: 'Sind Sie sicher, dass Sie die persönliche Notiz aktualisieren möchten?',
        },
        maia: {
          name: 'Maia',
          subtitle: 'Styling Support',
          openChat: 'Frag Maia',
          you: 'Du',
          placeholder: 'Nachricht schreiben..',
          viewProduct: 'Produkt ansehen',
          greeting: 'Hallo! Ich helfe dir gerne beim Zusammenstellen dieser Box. Womit möchtest du anfangen?',
          greetingNamed: 'Hallo! Ich helfe dir gerne bei der Box für {customer}. Womit möchtest du anfangen?',
          error: 'Sorry, ich konnte gerade keine Antwort abrufen. Versuch es noch einmal.',
          suggestions: {
            jeans: 'Welche Jeans passen zu dieser Kundin?',
            eyeCatcher: 'Schlage einen Eye-Catcher unter 150 € vor',
            missing: 'Was fehlt in dieser Box noch?',
          },
          // Der Abgleich mit dem Kundinnenprofil, pro Empfehlung. Die Schlüssel
          // kommen aus dem Backend (MaiaRecommendationCheck), damit der Text
          // in der Sprache der Stylistin steht und nicht in der des Modells.
          checks: {
            notChecked: 'Nicht prüfbar',
            over: '{amount} über Budget',
            breaks: '{rule} passt nicht',
            rules: {
              size: 'Größe',
              colour: 'Farbe',
              dress: 'kein Kleid',
              budget: 'Budget',
              wishlist: 'auf ihrer Wunschliste',
              fabric: 'Stoff',
              print: 'Print',
              camouflage: 'Kaschieren',
              profile: 'kein Profil',
            },
          },
        },
      },
    },
  },
  mfaSetup: {
    mfaNotYetSetup: 'MFA noch nicht eingerichtet',
    mfa: "MFA einrichten",
    mfaSetup: "MFA-Token einrichten",
    step1: "Nehmen Sie Ihr Telefon zur Hand.",
    step1_ios: 'Wenn Sie ein <b>iPhone</b> haben, öffnen Sie den App Store und suchen Sie nach <b>"Step Two"</b>.',
    step1_android: 'Wenn Sie ein <b>Android-Telefon</b> haben, öffnen Sie den Play Store und suchen Sie nach <b>"Google Authenticator"</b>.',
    step1_download: "Laden Sie diese App dann auf Ihr Telefon herunter.",
    step2: "Öffnen Sie die gerade heruntergeladene App und fügen Sie das Token hinzu",
    step2_steptwo: '<b>Step Two</b>: Tippen Sie auf das + Symbol und scannen Sie den QR-Code unten:',
    step2_google: '<b>Google Authenticator</b>: Starten Sie die Einrichtung und tippen Sie auf “Barcode scannen”.',
    step2_scan: "Scannen Sie jetzt den untenstehenden QR-Code.",
    step3: "Nach dem Scannen des QR-Codes sehen Sie einen 6-stelligen Code mit einem Timer. Dieser läuft alle 30 Sekunden ab.",
    step4: 'Geben Sie den Code aus Ihrer App in <b>"Token 1"</b> ein.',
    step5: "Warten Sie, bis der Code abläuft, und geben Sie dann den neuen Code in <b>'Token 2'</b> ein.",
    step6: 'Beenden Sie die Einrichtung mit der Schaltfläche <b>"Token speichern"</b>.',
    token1_label: "Token 1",
    token2_label: "Token 2",
    save_token: "Token speichern",
    cancel: "Abbrechen"
  }
};
